/* istanbul ignore file */
import React from 'react';
import { ButtonsSelectInput, ButtonsSelectInputProps } from 'framework/form';
import { MappingMetricsTypeLabels } from 'domain/finance/costAccounting/shared/costAccountingService';

const MappingMetricsTypeInput = (props: ButtonsSelectInputProps) => {
  return (
    <ButtonsSelectInput
      {...props}
      options={Object.entries(MappingMetricsTypeLabels).map(entry => {
        const [value, label] = entry;

        return {
          label,
          value,
        };
      })}
    />
  );
};

export default MappingMetricsTypeInput;
